var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReplenishIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_167028",
    "data-name": "Group 167028",
    transform: "translate(-39 -55)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167018",
    "data-name": "Group 167018",
    transform: "translate(42.904 58.988)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Line_152",
    "data-name": "Line 152",
    d: "M16,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H16a1,1,0,0,1,1,1A1,1,0,0,1,16,1Z",
    transform: "translate(0.096 7.631)",
    fill: "#1c2023"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_153",
    "data-name": "Line 153",
    d: "M16,1H0A1,1,0,0,1-1,0,1,1,0,0,1,0-1H16a1,1,0,0,1,1,1A1,1,0,0,1,16,1Z",
    transform: "translate(8.096 0.012) rotate(90)",
    fill: "#1c2023"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReplenishIcon);
export default __webpack_public_path__ + "static/media/replenish_icon.bfd9ddf125aa617f381b5824b1104b2b.svg";
export { ForwardRef as ReactComponent };